import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Notification } from '../../../../core/Notifications/Notification';
import { Router } from '@angular/router';
import { DialogContentExample1Component } from '../../dialog-content-example1/dialog-content-example1.component';
import { AppoinmentserviceService } from '../../add-appoinments/appoinmentservice.service';

@Component({
  selector: 'app-editdialog',
  templateUrl: './editdialog.component.html',
  styleUrls: ['./editdialog.component.scss']
})
export class EditdialogComponent implements OnInit {

  test: any;
  doctordd: any;
  enable=true;
  enables=true;
  clinicalshow:boolean;
  hospitalshow:boolean;
  selected = 0;
  data: any;
  isDisabled=true;
  hospitaldd: any;
  testhosid: any;
  constructor(@Inject(MAT_DIALOG_DATA) private _data: any,public dialog: MatDialog,private AppoinmentserviceService: AppoinmentserviceService,
  private notify: Notification,private router: Router,) { }

  ngOnInit(): void {
    console.log("editappn" ,  this._data)
    this.selected=this._data.appt_DO_Id_FK;
  }

  showdoctr() {
    this.enable=false;
    this.enables = true;
    this.GetDoctorList_BasedonSchedule();
    
  }
  
  showhosptl() {
    this.enable=true;
    this.enables = false;
    this.get_hospitaldd();
    // this.hospitalshow=true;
    // const dialogRef = this.dialog.open(ShowhospitalComponent,
    //   {
    //     height: '65%',
    //     width: '65%',
    //   });

    // dialogRef.afterClosed().subscribe(result => {
    //   console.log(`Dialog result: ${result}`);
    //   // if (result != undefined) {
    //   //   this.test = result.dO_Name;
    //   //   this.appoinmentForm.controls['Appt_DO_Id_FK'].setValue(result.dO_Id);
    //   // }
    //   //   setTimeout(() => {
    //   //     window.location.reload();
    //   // }, 2000);
    // });
  }
  DoctorDD(data) {
    console.log(data)
    this.testhosid = data
    this.get_doctordd(data);
    // this.GetDoctorList_BasedonSchedule();
  }

  get_doctordd(HospitalId) {
    this.AppoinmentserviceService.get_doctorbyhospitalId(HospitalId)
      .subscribe((data) => {
        this.doctordd = data
        console.log(this.doctordd)
      })
  }

  saveForm() {
    this._data.Appt_DO_Id_FK=this.selected
    console.log('Form data is',this._data);
    this.AppoinmentserviceService.Post_appoinment(this._data)
    .subscribe((data: any) => {
      this._data = data
      this.openDialog();
      console.log(this._data);
    })
    this.notify.successmsg("Appoinment" + " fixed Successfully.");
    this.router.navigate(["/base/patient/Appoinment"]);
  }

  openDialog() {
    const dialogRef = this.dialog.open(DialogContentExample1Component);
    dialogRef.afterClosed().subscribe(result => {
      console.log(`Dialog result: ${result}`);
    });
  }
  GetDoctorList_BasedonSchedule() {
    console.log('Test', this.testhosid);
    this.AppoinmentserviceService.GetDoctorList_BasedonSchedule(this._data.select_day, this._data.select_FrmTime, this._data.select_toTime,0,0)
      .subscribe((data) => {
        this.doctordd = data
        console.log(this.doctordd)
      })
  }
  get_hospitaldd() {
    this.AppoinmentserviceService.Get_HospitalDD()
      .subscribe((data) => {
        this.hospitaldd = data
      })
  }

}
